import type { ApiLangPack, ApiLanguage } from '../../api/types';

interface BuiltinLanguage {
  langCode: string;
  name: string;
  nativeName: string;
  rtl?: true;
  load: () => Promise<ApiLangPack>;
}

export const BUILTIN_LANGUAGES: BuiltinLanguage[] = [
  {
    langCode: 'en',
    name: 'English',
    nativeName: 'English',
    load: async () => (await import('./en.json')).default as ApiLangPack,
  },
  {
    langCode: 'ru-RU',
    name: 'Russian',
    nativeName: 'Русский',
    load: async () => (await import('./ru-RU.json')).default as ApiLangPack,
  },
];

export function getBuiltinLanguage(langCode: string): BuiltinLanguage | undefined {
  return BUILTIN_LANGUAGES.find((lang) => lang.langCode === langCode);
}

export async function loadBuiltinLangPack(langCode: string): Promise<ApiLangPack | undefined> {
  const lang = getBuiltinLanguage(langCode);
  return lang ? await lang.load() : undefined;
}

export function getBuiltinLanguageInfo(): ApiLanguage[] {
  return BUILTIN_LANGUAGES.map(({ load, ...info }) => info);
}
